import mixpanel from "mixpanel-browser";

let initialized = false;

export function initMixpanel(mixPanelProjectId?: string) {
  if (!mixPanelProjectId || initialized) return;

  mixpanel.init(mixPanelProjectId, {
    autocapture: false,
    record_sessions_percent: 0,
  });

  initialized = true;
}

export function isMixpanelInitialized(): boolean {
  return initialized;
}

